var albums = [
{
  id: 1,
  name: "我的第一本彩色音符書",
  amountOfSongs: "33",
  // coverImg: "images/album_1",
  downloadLink: "https://bookcd-bookenv.s3-ap-northeast-1.amazonaws.com/%E6%88%91%E7%9A%84%E7%AC%AC%E4%B8%80%E6%9C%AC%E5%BD%A9%E8%89%B2%E9%9F%B3%E7%AC%A6%E6%9B%B8.zip"

},
{
  id: 2,
  name: "鋼琴教本 1",
  amountOfSongs: "44",
  // coverImg: "images/album_2",
  downloadLink: "https://bookcd-bookenv.s3-ap-northeast-1.amazonaws.com/%E7%A6%8F%E6%A8%82%E5%BD%88%E5%94%B1%E9%8B%BC%E7%90%B4%E6%95%99%E7%A8%8B-%E9%8B%BC%E7%90%B4%E6%95%99%E6%9C%AC1.zip"
},
{
  id: 3,
  name: "鋼琴教本 2",
  amountOfSongs: "51",
  // coverImg: "images/album_3",
  downloadLink: "https://bookcd-bookenv.s3-ap-northeast-1.amazonaws.com/%E7%A6%8F%E6%A8%82%E5%BD%88%E5%94%B1%E9%8B%BC%E7%90%B4%E6%95%99%E7%A8%8B-%E9%8B%BC%E7%90%B4%E6%95%99%E6%9C%AC2.zip"
},
{
  id: 4,
  name: "鋼琴教本 3",
  amountOfSongs: "46",
  // coverImg: "images/album_4",
  downloadLink: "https://bookcd-bookenv.s3-ap-northeast-1.amazonaws.com/%E7%A6%8F%E6%A8%82%E5%BD%88%E5%94%B1%E9%8B%BC%E7%90%B4%E6%95%99%E7%A8%8B-%E9%8B%BC%E7%90%B4%E6%95%99%E6%9C%AC3.zip"
},
{
  id: 5,
  name: "鋼琴表演本 1",
  amountOfSongs: "28",
  // coverImg: "images/album_5",
  downloadLink: "https://bookcd-bookenv.s3-ap-northeast-1.amazonaws.com/%E7%A6%8F%E6%A8%82%E5%BD%88%E5%94%B1%E9%8B%BC%E7%90%B4%E6%95%99%E7%A8%8B-%E9%8B%BC%E7%90%B4%E8%A1%A8%E6%BC%941.zip"
},
{
  id: 6,
  name: "鋼琴表演本 2",
  amountOfSongs: "28",
  // coverImg: "images/album_6",
  downloadLink: "https://bookcd-bookenv.s3-ap-northeast-1.amazonaws.com/%E7%A6%8F%E6%A8%82%E5%BD%88%E5%94%B1%E9%8B%BC%E7%90%B4%E6%95%99%E7%A8%8B-%E9%8B%BC%E7%90%B4%E8%A1%A8%E6%BC%942.zip"
},
{
  id: 7,
  name: "鋼琴表演本 3",
  amountOfSongs: "36",
  // coverImg: "images/album_7",
  downloadLink: "https://bookcd-bookenv.s3-ap-northeast-1.amazonaws.com/%E7%A6%8F%E6%A8%82%E5%BD%88%E5%94%B1%E9%8B%BC%E7%90%B4%E6%95%99%E7%A8%8B-%E9%8B%BC%E7%90%B4%E8%A1%A8%E6%BC%943.zip"
},
];

export default albums
